<template>
  <v-alert
    :value="!isOnline"
    type="warning"
    :icon="SbIcons.status.noConnection"
  >
    {{ offlineMessage }}
  </v-alert>
</template>

<script>
/**
 * This component will display itself when the browser loses
 * network connection
 */
export default {
  name: 'TheOfflineAlert',
  data() {
    return {
      offlineMessage: 'Network connection lost!',
      isOnline: navigator.onLine,
    };
  },
  created() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
    },
  },
};
</script>
